// localStorage key for refresh token expiration (Unix timestamp in seconds)
export const REFRESH_TOKEN_EXPIRATION_KEY = 'refresh_token_expiration'
